import * as React from 'react';

import { StileGtagEventName } from '../../../../types/services';

import { Link } from '../Link';
import './Button.css';

type ButtonProps = React.HTMLAttributes<HTMLAnchorElement> &
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    children?: never;
    style?: 'primary' | 'secondary' | 'grey' | 'white';
    size?: 'small' | 'normal' | 'large';
    label: string | React.ReactNode;
    href?: string;
    gtagEvent?: StileGtagEventName;
    external?: boolean;
    newTab?: boolean;
    type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type'];
    onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
    disabled?: React.ButtonHTMLAttributes<HTMLButtonElement>['disabled'];
  };

/**
 * Displays stile Button in different colours
 */
export const Button = ({
  style = 'primary',
  size = 'normal',
  label,
  href,
  external,
  newTab = false,
  className,
  type = 'button',
  onClick,
  disabled,
  ...props
}: React.PropsWithChildren<ButtonProps>) => {
  const buttonClassName = `button --${style} --${size} ${className || ''}`;

  // If type is specified or no href is provided, render as a button
  if (type != 'button' || !href) {
    return (
      <button
        type={type}
        className={buttonClassName}
        onClick={onClick}
        disabled={disabled}
        {...props}
      >
        {label}
      </button>
    );
  } else {
    return (
      <Link
        url={href}
        className={`button --${style} --${size} ${className}`}
        external={external}
        target={newTab ? '_blank' : undefined}
        onClick={onClick}
        {...props}
      >
        {label}
      </Link>
    );
  }
};
